import type { GetServerSidePropsContext } from "next";

import { isBrowser } from "../isBrowser";

const COOKIE_NAME = "flare-e2e-test";
const COOKIE_VALUE = "true";

export function isE2ETest(context?: GetServerSidePropsContext) {
  if (isBrowser()) {
    return document.cookie.includes(`${COOKIE_NAME}=${COOKIE_VALUE}`);
  }

  if (context) {
    return context.req.headers.cookie?.includes(
      `${COOKIE_NAME}=${COOKIE_VALUE}`,
    );
  }

  return false;
}
